module.exports = __webpack_public_path__ + "img/right-move-cursor.1c254293.svg";